import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (shopData) {
  return {
    name: shopData.name,
    platformCountryId: shopData.platform.value,
    sortNumber: shopData.sortNumber
  }
}
export default { request }
